import CreditsInstallmentsPage from "@/modules/user/components/credits/creditsInstallments";
import WalletBalance from "@/modules/user/components/walletReports/walletBalance";
import HomeUser from "@/modules/user/pages";
import CreditsPage from "@/modules/user/pages/Credits";
import CreditsInstallmentPage from "@/modules/user/pages/Credits/creditsInstallments";
import DetailInstallmentPage from "@/modules/user/pages/Credits/detailInstallment";
import ReputableStorePage from "@/modules/user/pages/Credits/reputableStore";
import StorePointsPages from "@/modules/user/pages/Credits/store-points";
import ValidationPage from "@/modules/user/pages/Credits/validation";
import LocationPages from "@/modules/user/pages/location";
import DetailUserLocationPage from "@/modules/user/pages/location/detailUserLocation";
import LocationMerchantPage from "@/modules/user/pages/location/locationMerchant";
import LoginPage from "@/modules/user/pages/login";
import SupportPage from "@/modules/user/pages/support";
import SupportMessagePage from "@/modules/user/pages/support/supportMessage";
import AddShetabCardPage from "@/modules/user/pages/walletReports/addShetabCard";
import BalanceTransferPage from "@/modules/user/pages/walletReports/balanceTransfer";
import CashBalanceRechargePage from "@/modules/user/pages/walletReports/cashBalanceRecharge";
import WithdrawFromWalletPage from "@/modules/user/pages/walletReports/withdrawFromWallet";
import { lazy } from "react";
import PrivateRoute from "./PrivateRoute";
import MessageListPage from "@/modules/user/pages/messageList";
// const DashboardAdmin = lazy(() => import("@/modules/merchant/pages/dashboard"));
const ProfilePage = lazy(() => import("@/modules/user/pages/profile"));
const WalletReportsPage = lazy(() => import("@/modules/user/pages/walletReports"));
const WalletBalancePage = lazy(() => import("@/modules/user/pages/walletReports/walletBalance"));
/**

useUserRoutes

آرایه‌ای از مسیرهای اپلیکیشن برای کاربران عادی (User) که شامل مسیرهای عمومی و خصوصی است.

مسیرهای خصوصی با استفاده از PrivateRoute محافظت شده‌اند تا تنها کاربران دارای توکن دسترسی داشته باشند.

مسیرهای موجود:

"/" : صفحه اصلی کاربر

"/profile" : صفحه پروفایل کاربر

"/wallet-reports" : بخش گزارش ها کیف پول

- "wallet-balance" : موجودی کیف پول

- "balance-transfer" : انتقال موجودی

- "withdraw-from-wallet" : برداشت از کیف پول

- "cash-balance-recharge" : شارژ نقدی کیف پول

- "add-shetab-card" : افزودن کارت شتاب


"/credits" : بخش اعتبارات

- "validation" : اعتبارسنجی

- "credits-installments" : اقساط اعتباری

- "store-points" : امتیاز فروشگاه

- "reputable-store" : فروشگاه معتبر

- "add-shetab-card" : افزودن کارت شتاب

- "/credits/:id" : جزئیات قسط اعتباری مشخص


"/locations" : مدیریت موقعیت‌ها

- "merchant" : مکان‌های پذیرنده

- "map" : نمایش موقعیت کاربران


"/support" : پشتیبانی

- "message" : پیام‌های پشتیبانی


"/login" : صفحه ورود (عمومی)

تمام مسیرهای خصوصی با PrivateRoute محافظت شده‌اند.

@type {Array<{ path: string, element: JSX.Element, children?: Array<any> }>}
*/
export const useUserRoutes = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <HomeUser />
      </PrivateRoute>
    ),
  },

  {
    path: "/profile",
    element: (
      <PrivateRoute>
        <ProfilePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/wallet-reports",
    element: (
      <PrivateRoute>
        <WalletReportsPage />
      </PrivateRoute>
    ),
    children: [
      {
        path: "wallet-balance",
        element: <WalletBalancePage />,
      },
      {
        path: "balance-transfer",
        element: <BalanceTransferPage />,
      },
      {
        path: "withdraw-from-wallet",
        element: <WithdrawFromWalletPage />,
      },
      {
        path: "cash-balance-recharge",
        element: <CashBalanceRechargePage />,
      },
      {
        path: "add-shetab-card",
        element: <AddShetabCardPage />,
      },
    ],
  },
  {
    path: "/credits",
    element: (
      <PrivateRoute>
        <CreditsPage />
      </PrivateRoute>
    ),
    children: [
      {
        path: "validation",
        element: <ValidationPage />,
      },
      {
        path: "credits-installments",
        element: <CreditsInstallmentPage />,
      },
      {
        path: "store-points",
        element: <StorePointsPages />,
      },
      {
        path: "reputable-store",
        element: <ReputableStorePage />,
      },
      {
        path: "add-shetab-card", // اضافه کردن کارت
        element: <AddShetabCardPage />,
      },
      {
        path: "/credits/:id",
        element: <DetailInstallmentPage />,
      },
    ],
  },
  {
    path: "/locations",
    element: (
      <PrivateRoute>
        <LocationPages />
      </PrivateRoute>
    ),
    children: [
      {
        path: "merchant",
        element: <LocationMerchantPage />,
      },
      {
        path: "map",
        element: <DetailUserLocationPage />,
      },
    ],
  },
  {
    path: "/support",
    element: (
      <PrivateRoute>
        <SupportPage />
      </PrivateRoute>
    ),
    children: [
      {
        path: "message",
        element: <SupportMessagePage />,
      },

    ],
  },
  {
    path: "/list-message",
    element: (
      <PrivateRoute>
        <MessageListPage />
      </PrivateRoute>
    )
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
];
